module.exports = function getResource(label, vars = []) {
    const resources = { chooseLocation: 'Choisir un lieu' };
    return resources[label];
};
